import quickFetch from 'quick-fetch';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
export function queryQuickFetch(earlyRequestName, fetch) {
  const earlyMetaRequest = quickFetch.getRequestStateByName(earlyRequestName);
  let resultPromise;
  if (earlyMetaRequest) {
    resultPromise = new Promise((resolve, reject) => {
      earlyMetaRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(earlyRequestName);
      });
      earlyMetaRequest.onError(() => {
        fetch().then(resolve, reject).catch(error => logRavenException(error, 'Query Quick Fetch'));
        quickFetch.removeEarlyRequest(earlyRequestName);
      });
    });
  } else {
    resultPromise = fetch();
  }
  return resultPromise;
}